/* eslint-disable no-console */
import { makeVar } from "@apollo/client";

export type LastActiveInvestingEntityMap = {
	[accountId: string]: string; // mapping of accountId → investingEntityId
};

const localStorageKey = "last_active_investing_entity_map";

export const lastActiveInvestingEntityVar =
	makeVar<LastActiveInvestingEntityMap>({});

export const setLastActiveInvestingEntity = ({
	investingEntityId,
	accountId,
}: {
	investingEntityId: string;
	accountId: string;
}) => {
	try {
		const raw = localStorage.getItem(localStorageKey);
		const current = raw ? JSON.parse(raw) : {};
		const updated = {
			...current,
			[accountId]: investingEntityId,
		};

		localStorage.setItem(localStorageKey, JSON.stringify(updated));
		lastActiveInvestingEntityVar(updated);
	} catch {
		console.error("Error saving last active investing entity");
	}
};

export const hydrateLastActiveInvestingEntity = () => {
	try {
		const raw = localStorage.getItem(localStorageKey);
		if (raw) {
			const parsed: LastActiveInvestingEntityMap = JSON.parse(raw);
			lastActiveInvestingEntityVar(parsed);
			console.log("parsed", parsed);
		}
	} catch {
		console.error("Error parsing last active investing entity map");
	}
};
